import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated in React 18
import './index.css'; // Optional: if you have global styles
import App from './App';

// For React 18 and above
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
